import { render, staticRenderFns } from "./order.vue?vue&type=template&id=63f5d3a8&scoped=true&"
var script = {}
import style0 from "./order.vue?vue&type=style&index=0&id=63f5d3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5d3a8",
  null
  
)

export default component.exports